// extracted by mini-css-extract-plugin
export default {"signOutLink":"SignOutLink_signOutLink__1ZfS2"};